import { cva } from 'class-variance-authority'

export const anchorLinkVariants = cva('block truncate border-l-2 py-2.5 pl-4 transition-colors', {
  variants: {
    active: {
      true: 'border-main-border-accent text-main-foreground-primary text-label-default',
      false:
        'border-transparent text-main-foreground-tertiary text-body-default hover:text-main-foreground-secondary',
    },
  },
  defaultVariants: {
    active: false,
  },
})
